import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const refrigeratorApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRefrigerators: builder.mutation({
      query: (data) => ({
        url: `/refrigerators/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getRefrigeratorById: builder.mutation({
      query: (data) => ({
        url: `/refrigerators/getbyid?${getFilters(data)}`,
        method: "GET",
      })
    }),
    getRefrigeratorTypes: builder.mutation({
      query: (data) => ({
        url: `/refrigeratortypes/get?${getFilters(data)}`,
        method: "GET",
      })
    }),
    editRefrigerator: builder.mutation({
      query: (data) => ({
        url: `/refrigerators/edit`,
        method: "PUT",
        body: data
      })
    }),
    getRefrigeratorLogs: builder.mutation({
      query: (data) => ({
        url: `/refrigerators/log?${getFilters(data)}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useGetRefrigeratorsMutation,
  useGetRefrigeratorByIdMutation,
  useGetRefrigeratorTypesMutation,
  useEditRefrigeratorMutation,
  useGetRefrigeratorLogsMutation
} = refrigeratorApiSlice;
